import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import TitlePages from "../../layout/TitlePages";
import Breadcrumbs from "../../layout/Breadcrumbs";
import IconoCarpeta from "../../components/IconoCarpeta";
import "./Acuerdos.css";

const ACUERDOS_PORTALES = [
  {
    to: "/Distritacion2015",
    anio: "2015",
    badge: "Proceso 2015",
    titulo: "Distritación 2015",
    descripcion:
      "Acuerdos del Consejo General del INE, resoluciones y anexos técnicos de la distritación electoral.",
    meta: "6 acuerdos disponibles",
  },
  {
    to: "/Distritacion2022",
    anio: "2022",
    badge: "Proceso 2022",
    titulo: "Distritación 2022",
    descripcion:
      "Acuerdos relativos a la demarcación y conformación distrital electoral local y federal.",
    meta: "4 acuerdos disponibles",
  },
];

const PortalCard = ({ to, anio, badge, titulo, descripcion, meta }) => (
  <Link
    to={to}
    className="demarcaciones-hub-card"
    aria-label={`${titulo} - ${descripcion}`}
  >
    <div className="demarcaciones-hub-badge">{badge}</div>

    <div className="demarcaciones-hub-icon-wrap">
      <IconoCarpeta anio={anio} />
    </div>

    <div className="demarcaciones-hub-body">
      <h3 className="demarcaciones-hub-title">{titulo}</h3>
      <p className="demarcaciones-hub-desc">{descripcion}</p>
    </div>

    <div className="demarcaciones-hub-footer">
      <span className="demarcaciones-hub-meta">{meta}</span>
      <span className="demarcaciones-hub-btn">
        Consultar acuerdos
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <line x1="5" y1="12" x2="19" y2="12" />
          <polyline points="12 5 19 12 12 19" />
        </svg>
      </span>
    </div>
  </Link>
);

PortalCard.propTypes = {
  to: PropTypes.string.isRequired,
  anio: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  badge: PropTypes.string.isRequired,
  titulo: PropTypes.string.isRequired,
  descripcion: PropTypes.string.isRequired,
  meta: PropTypes.string.isRequired,
};

const Acuerdos = () => {
  useEffect(() => {
    document.title = `Acuerdos Demarcaciones`;
  }, []);

  return (
    <>
      <Breadcrumbs
        path={[{ label: "Demarcaciones" }, { label: "Acuerdos" }]}
      />
      <TitlePages title="Acuerdos" subTitle="Demarcaciones Electorales" />

      <div className="demarcaciones-acuerdos-section">
        <div className="demarcaciones-hub-grid">
          {ACUERDOS_PORTALES.map((item) => (
            <PortalCard key={item.to} {...item} />
          ))}
        </div>
      </div>
    </>
  );
};

export default Acuerdos;
